import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FileText, ExternalLink } from "lucide-react";

const thisMonth = () => new Date().toISOString().slice(0, 7);

/** Profile → Statements. Opens a printable statement in a new tab. */
export const StatementsCard = () => {
  const [month, setMonth] = useState(thisMonth());

  const open = () => {
    window.open(`${process.env.REACT_APP_BACKEND_URL}/api/statements/${month}/html`, "_blank", "noopener");
  };

  return (
    <Card className="p-5 shadow-premium" data-testid="statements-card">
      <div className="flex items-center gap-2 text-sm font-medium">
        <FileText className="h-4 w-4 text-[color:var(--tharwy-indigo)]" />Statements
      </div>
      <p className="mt-1.5 text-xs text-muted-foreground leading-relaxed">
        Your month in one page: cash at the close, holdings, every trade, every movement and the fees
        you paid. Print it or save it as a PDF from your browser.
      </p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:items-end">
        <div className="flex-1">
          <Label className="text-xs">Month</Label>
          <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)}
            className="mt-1.5" data-testid="statement-month-input" />
        </div>
        <Button onClick={open} className="shrink-0" data-testid="statement-open-btn">
          <ExternalLink className="h-4 w-4 me-1.5" />Open statement
        </Button>
      </div>
    </Card>
  );
};
